<template>
    <div>
        <div slot="title" class="flex">
            <span class="w-1/5">{{ quantity }}x</span>
            <span class="w-2/5">{{ name }}</span>
            <span class="w-1/5">
                <vs-icon icon="remove" @click="decreaseQuantity"></vs-icon>
                <vs-icon icon="add" @click="increaseQuantity"></vs-icon>
            </span>
            <span class="w-1/5">&euro;{{ totalPrice }}</span>
            <vs-icon class="w-1/5" @click="removeItem" icon="delete"></vs-icon>
        </div>
        <div slot="subtitle">
            <cart-item-addon v-for="(addon, index) in addons"
                :key="addon.id"
                :addon_id="addon.id"
                :name="addon.name"
                :price="addon.price"
                :category="addon.category"
                :addons="addon.addons"
                :multiple="addon.multiple">
                <span v-if="!(addons.length -1 === index)">, </span>
            </cart-item-addon>
            <span v-if="note">{{ note }}</span>
        </div>
    </div>
</template>

<script>

    import cartItemAddon from './CartItemAddon.vue';

    export default {
        mounted() {
            console.log('CartItem mounted.');
        },
        components: {
          'cart-item-addon': cartItemAddon
        },
        data() {
          return {}
        },
        props: ['product_id', 'product_uuid', 'name', 'quantity', 'price', 'sale_price', 'addons', 'note', 'last'],
        computed: {
            totalPrice: function() {
                var price = Number(this.price);
                if(this.addons !== undefined) {
                    if(this.addons.length > 0) {
                        this.addons.map(addon => {
                            if(addon.price !== null) {
                                price = price + Number(addon.price);
                            }
                        })
                    }
                }
                return this.quantity * price;
            }
        },
        watch: {},
        methods: {
            decreaseQuantity: function() {
                this.$events.fire('decreasedCartItemQty', this.product_uuid);
            },
            increaseQuantity: function() {
                this.$events.fire('increasedCartItemQty', this.product_uuid);
            },
            removeItem: function() {
                this.$events.fire('removeItem', this.product_uuid);
            }
        }
    }
</script>
